<template>
  <div>
    <h3 class="header-title">Learning</h3>
    <label>Let’s see your tuition progress.</label>
    <br />
    <!-- <CButton type="button" color="info" @click="GoToOldSubject()" cursor="pointer">List Subject</CButton>
    <CButton type="button" color="info" class="ml-2" @click="GoToOldPackage()" cursor="pointer">List Package</CButton>
    <CButton type="button" color="info" class="ml-2" @click="GoToOldStudent()" cursor="pointer">List Student</CButton>
    <CButton type="button" color="info" class="ml-2" @click="GoToOldTeacher()" cursor="pointer">List Teacher</CButton>
    <CButton type="button" color="info" class="ml-2" @click="GoToOldStudentAttendance()" cursor="pointer">List Attendance Student</CButton>
    <CButton type="button" color="info" class="ml-2" @click="GoToOldTeacherAttendance()" cursor="pointer">List Attendance Teacher</CButton> -->
    <CRow class="mt-3">
      <CCol sm="3">
        <CCard>
          <div style="height: 140px">
            <h5 class="custom-subtitle-card m-2">Total Subjects</h5>
            <h3 class="custom-52px mt-3 ml-2 mt-3">{{ subject }}</h3>
           <label class="custom-16px ml-2 mt-4 pointer" @click="GoToSubject()">View All</label
            >
          </div>
        </CCard>
      </CCol>
      <CCol sm="3">
        <CCard>
          <div style="height: 140px">
            <h5 class="custom-subtitle-card m-2">Total Packages</h5>
            <h3 class="custom-52px mt-3 ml-2 mt-3">{{ packages }}</h3>
            <label class="custom-16px ml-2 mt-4 pointer">View All</label>
          </div>
        </CCard>
      </CCol>
      <CCol sm="3">
        <CCard>
          <div style="height: 140px">
            <h5 class="custom-subtitle-card m-2">Total Active Students</h5>
            <h3 class="custom-52px mt-3 ml-2 mt-3">{{ students }}</h3>
            <label class="custom-16px ml-2 mt-4 pointer">View All</label>
          </div>
        </CCard>
      </CCol>
      <CCol sm="3">
        <CCard>
          <div style="height: 140px">
            <h5 class="custom-subtitle-card m-2">Total Active Teachers</h5>
            <h3 class="custom-52px mt-3 ml-2 mt-3">{{ teachers }}</h3>
            <label class="custom-16px ml-2 mt-4 pointer">View All</label>
          </div>
        </CCard>
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="5">
        <CCard class="">
          <h5 class="custom-subtitle-card m-2 ml-3">Student</h5>
          <CRow class="ml-2">
            <CCol sm="8"><h6><strong>Name</strong></h6></CCol>
            <CCol sm="4"><h6><strong>Grade</strong></h6></CCol>
            <div style="clear:both"></div>
            <br />
            <hr />
            <CCol sm="12">
              <CRow v-for="item in studentList.slice(0, 5)" v-bind:key="item.Id" class="mt-2 mb-2">
              <CCol sm="8">{{ item.Name }}   <img style="height:20px" src="../assets/img/new.svg" class="ml-2 mr-2" /></CCol>
              <CCol sm="4">{{ item.Grade }}</CCol>
            </CRow>
            <label class="custom-16px ml-2 mt-4 pointer" @click="GoToStudent()">View All</label
            >
            </CCol>
          
          </CRow>
        </CCard>
      </CCol>
      <CCol sm="7">
        <CCard class="">
          <h5 class="custom-subtitle-card m-2 ml-3">Teacher</h5>
          <CRow class="ml-2">
            <CCol sm="5"><h6><strong>Name</strong></h6></CCol>
            <CCol sm="7"><h6><strong>Subject</strong></h6></CCol>
            <div style="clear:both"></div>
            <br />
            <hr />
            <CCol sm="12">
              <CRow v-for="item in teacher.slice(0, 5)" v-bind:key="item.Id" class="mt-2 mb-2">
              <CCol sm="5">{{ item.Name }}   <img style="height:20px" src="../assets/img/new.svg" class="ml-2 mr-2" /></CCol>
              <CCol sm="7">
                <span v-for="item in item.Subject" v-bind:key="item.Id" class="text-left">
                {{ item.Name }} ,</span>
              </CCol>
            </CRow>
            </CCol>
            <label class="custom-16px ml-2 mt-4 pointer" @click="GoToStudent()">View All</label
            >
          
          </CRow>
        </CCard>
      </CCol>
    </CRow>


 

    <CRow class="mt-1">
      <CCol sm="6">
        <CCard>
          <div class="custom-height-md">
            <h5 class="custom-subtitle-card m-2 ml-3">Teacher Apply</h5>
            <h3 class="custom-52px mt-3 ml-2 mt-3 mb-5 ml-3">
              {{ respondcount }}
            </h3>
            <CCard class="custom-explore text-white p-3 ml-3 mr-3">
              <CRow>
                <CCol sm="4">Find Tutor ID</CCol>
                <CCol sm="4">Student Info</CCol>
                <CCol sm="4">Time</CCol>
              </CRow>
            </CCard>
            <div>
              <CCol sm="12">
                <CCard
                  v-for="item in respond.slice(0, 3)"
                  v-bind:key="item.Id"
                  class="p-2 custom-box-shadow m-2"
                >
                  <CRow>
                    <CCol sm="4">
                      <label>
                        {{ item.FindTutorId }}
                        <img
                          src="../assets/img/check-circle.svg"
                          class="ml-2 mr-2"
                        />
                        <img style="height:20px" src="../assets/img/new.svg" class="ml-2 mr-2" />
                      </label>
                    </CCol>
                    <CCol sm="4">
                      <b class="text-custom-primary">
                        Student ID: {{ item.StudentId }}</b
                      >
                      <br />
                      <b> Name:</b> {{ item.StudentName }}<br />
                      <b> Grade:</b> {{ item.GradeName }}<br />
                      <b> Subject:</b> {{ item.SubjectName }}
                    </CCol>
                    <CCol sm="4">
                      {{ item.CreatedTime | moment("DD MMM YYYY") }} |
                      {{ item.CreatedTime | moment("hh:mm") }}
                    </CCol>
                  </CRow>
                </CCard>
              </CCol>
            </div>
          </div>
        </CCard>
      </CCol>
      <CCol sm="6">
        <CCard>
          <div class="custom-height-md">
            <h5 class="custom-subtitle-card m-2 ml-3">Still Open</h5>
            <h3 class="custom-52px mt-3 ml-2 mt-3 mb-5 ml-3">
              {{ waitingcount }}
            </h3>
            <CCard class="custom-explore text-white p-3 ml-3 mr-3">
              <CRow>
                <CCol sm="4">Find Tutor ID</CCol>
                <CCol sm="4">Subject Info</CCol>
                <CCol sm="4">Time</CCol>
              </CRow>
            </CCard>
            <div>
              <CCol sm="12">
                <CCard
                  v-for="item in waiting.slice(0, 3)"
                  v-bind:key="item.Id"
                  class="p-2 custom-box-shadow m-2"
                >
                  <CRow>
                    <CCol sm="4">
                      <label>
                        {{ item.FindTutorId }}
                        <img
                          src="../assets/img/check-circle.svg"
                          class="ml-2 mr-2"
                        />
                        <img style="height:20px" src="../assets/img/new.svg" class="ml-2 mr-2" />
                      </label>
                    </CCol>
                    <CCol sm="4">
                      <b class="text-custom-primary">
                        Subject ID:{{ item.SubjectId }}</b
                      >
                      <br />
                      <b> Subject:</b> {{ item.Subject }}<br />
                    </CCol>
                    <CCol sm="4">
                      {{ item.Createdtime | moment("DD MMM YYYY") }} |
                      {{ item.Createdtime | moment("hh:mm") }}
                    </CCol>
                  </CRow>
                </CCard>
              </CCol>
            </div>
          </div>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>
  
  
  <script>
import Vue from "vue";
import FullCalendar from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.css";
import backgroundUrl from "../assets/img/bgtips.png";
import moment from "moment";
Vue.use(require("vue-moment"));

import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { CChartBar } from "@coreui/vue-chartjs";
import VueEllipseProgress from "vue-ellipse-progress";

//import "@fullcalendar/core/vdom"; // solves problem with Vite]

import { Calendar } from "vue-sweet-calendar";
import "vue-sweet-calendar/dist/SweetCalendar.css";

Vue.use(FullCalendar);
Vue.use(VueEllipseProgress);

export default {
  name: "Collapses",
  components: {
    PulseLoader,
    CChartBar,
    Calendar,
  },
  data() {
    return {
      backgroundUrl,
      user: {},
      subject: 0,
      packages: 0,
      students: 0,
      teachers: 0,
      respond: [],
      waiting: [],
      respondcount: 0,
      waitingcount: 0,
      studentList: [],
      teacher: [],
    };
  },
  async mounted() {
    this.SessionUserIdNo();
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetNews();
      this.GetUserProfile();
      this.GetListChild();
      this.GetUserStudent();
      this.GetAuthorizeProfile();
      this.GetSubjectCount();
      this.GetPackageCount();
      this.GetStudentCount();
      this.GetTeacherCount();
      this.GetTeacherApply();
      this.GetTeacherWaiting();
      this.GetTeacherApplyCount();
      this.GetTeacherWaitingCount();
      this.GetStudent();
      this.GetTeacher();
    } else {
      this.GoToLogin();
    }
  },
  computed: {},

  methods: {
    SessionUserIdNo() {
      return this.$API
        .get(this.$LoginUserDetailAdmin, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetSubjectCount();
            this.GetPackageCount();
            this.GetStudentCount();
            this.GetTeacherCount();
            this.GetTeacherApply();
            this.GetTeacherWaiting();
            this.GetTeacherApplyCount();
            this.GetTeacherWaitingCount();
            this.GetStudent();
            this.GetTeacher();
          }
        });
    },
    GetStudent() {
      this.Busy = true;
      this.$API
        .get(this.$ViewStudentHome, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentList = response.data;
          }
        });
    },
    GetTeacher() {
      this.Busy = true;
      this.$API
        .get(this.$ViewTeacher, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.teacher = response.data;
          }
        });
    },
    GetSubjectCount() {
      return this.$API
        .get(this.$GetListSubjectTc, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.subject = response.data.length;
          }
        });
    },
    GetPackageCount() {
      return this.$API
        .get(this.$ViewPackage, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.packages = response.data.length;
          }
        });
    },
    GetStudentCount() {
      return this.$API
        .get(this.$ViewStudent, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.students = response.data.length;
          }
        });
    },
    GetTeacherCount() {
      return this.$API
        .get(this.$ViewTeacher, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.teachers = response.data.length;
          }
        });
    },
    GetTeacherApply() {
      this.$API
        .get(this.$FindTutorTeacherApply, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.respond = response.data;
          }
        });
    },
    GetTeacherWaiting() {
      this.$API
        .get(this.$FindTutorStillOpen, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.waiting = response.data;
          }
        });
    },
    GetTeacherApplyCount() {
      this.$API
        .get(this.$FindTutorTeacherApply, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.respondcount = response.data.length;
          }
        });
    },
    GetTeacherWaitingCount() {
      this.$API
        .get(this.$FindTutorStillOpen, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.waitingcount = response.data.length;
          }
        });
    },
    GoToSubject() {
      this.$router.push("LearningSubject");
    },
    GoToStudent()
    {
      this.$router.push("LearningUser");
    },
    GoToOldSubject()
    {
      this.$router.push("TuitionSubject");

    },
    GoToOldPackage()
    {
      this.$router.push("TuitionPackage");
    },
    GoToOldStudent()
    {
      this.$router.push("TuitionStudent");

    },
    GoToOldTeacher()
    {
      this.$router.push("TuitionTeacher");
    },
    GoToOldStudentAttendance()
    {
      this.$router.push("TuitionAttendanceStudent");
    },
    GoToOldTeacherAttendance()
    {
      this.$router.push("TuitionAttendanceTeacher");
    },
  },
};
</script>
  <style scoped>
.c-app {
  font-family: montserrat, Sans-serif;
}
</style>